import { SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';
import {
  ComputerIcon,
  Moon02Icon,
  Sun03Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Link } from '@tanstack/react-router';

import { Authenticated, Unauthenticated } from 'convex/react';

import { useTheme } from '../hooks/use-theme';
import { Logo } from './Logo';
import { Button } from './ui/button';

export function Header() {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('system');
    } else {
      setTheme('light');
    }
  };

  const getThemeIcon = () => {
    if (theme === 'light') {
      return <HugeiconsIcon icon={Sun03Icon} size={16} strokeWidth={2} />;
    } else if (theme === 'dark') {
      return <HugeiconsIcon icon={Moon02Icon} size={16} strokeWidth={2} />;
    } else {
      return <HugeiconsIcon icon={ComputerIcon} size={16} strokeWidth={2} />;
    }
  };

  return (
    <header className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto px-8 flex h-16 items-center justify-between">
        <Link to="/" className="hover:opacity-80 transition-opacity">
          <Logo />
        </Link>

        <div className="flex items-center space-x-4">
          <Button
            onClick={cycleTheme}
            variant="ghost"
            size="icon"
            aria-label="Toggle theme"
          >
            {getThemeIcon()}
          </Button>
          <Unauthenticated>
            <SignInButton mode="modal">
              <Button>Sign In</Button>
            </SignInButton>
            <SignUpButton mode="modal">
              <Button variant="default">Sign Up</Button>
            </SignUpButton>
          </Unauthenticated>
          <Authenticated>
            <UserButton />
          </Authenticated>
        </div>
      </div>
    </header>
  );
}
